
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class CurrencySelect extends Vue {
    @Prop({ type: String, default: "Full Time" }) value!: string;
    @Prop({ type: Boolean, default: true }) withBorder!: boolean;
    @Prop({ type: String, default: undefined }) readonly getParentStyle?: string;

    get mappedValue(): DropdownOption[] {
      return [{ id: this.value, name: this.value }];
    }

    employmentTypeOptions: DropdownOption[] = [
      { id: "Full Time", name: "Full Time" },
      { id: "Part Time", name: "Part Time" },
      { id: "Contract", name: "Contract" },
      { id: "Freelance", name: "Freelance" },
    ];

    handleInput(val: DropdownOption[]): void {
      if (!val.length) {
        return;
      }

      this.$emit("input", val[0].id);
    }
  }
